<template lang="pug">
    .example
        .example__container
            .example__date-container
                span.example__date.example__date-box
                    | {{ $i18n.t('trainer.trainer_gamePlayBox_chooseDayOfWeekFor') }}&nbsp;
                span.example__date.example__date-box
                    |  {{ ' ' + exampleDate() }}&nbsp;
            span.example__date-picker
                cs-multiselect(
                    :options="daysOfWeek",
                    label="value",
                    v-model="answer",
                    :multiple="false"
                    :placeholder="$i18n.t('trainer.trainer_gamePlayBox_chooseDayOfWeek')"
                )
        template
            cs-button(
                @click="checkAnswer()",
                color="blue"
                :disabled="!startGame"
            )
                | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
</template>

<script>
    export default {
        props: {
            parameters: Object,
            example: String,
            startGame: {
                type: Boolean,
                default: false,
            },
            correct: {
                type: Boolean,
                default: false,
            },
            isBattle: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                answer: null,
                isFocused: false,
                focusTimeout: null,
                daysOfWeek: [
                    {
                        label: this.$i18n.t('elements.elements_datePicker_weekdayMon'),
                        value: this.$i18n.t('elements.elements_datePicker_weekdayMon'),
                    },
                    {
                        label: this.$i18n.t('elements.elements_datePicker_weekdayTue'),
                        value: this.$i18n.t('elements.elements_datePicker_weekdayTue'),
                    },
                    {
                        label: this.$i18n.t('elements.elements_datePicker_weekdayWed'),
                        value: this.$i18n.t('elements.elements_datePicker_weekdayWed'),
                    },
                    {
                        label: this.$i18n.t('elements.elements_datePicker_weekdayThu'),
                        value: this.$i18n.t('elements.elements_datePicker_weekdayThu'),
                    },
                    {
                        label: this.$i18n.t('elements.elements_datePicker_weekdayFri'),
                        value: this.$i18n.t('elements.elements_datePicker_weekdayFri'),
                    },
                    {
                        label: this.$i18n.t('elements.elements_datePicker_weekdaySat'),
                        value: this.$i18n.t('elements.elements_datePicker_weekdaySat'),
                    },
                    {
                        label: this.$i18n.t('elements.elements_datePicker_weekdaySun'),
                        value: this.$i18n.t('elements.elements_datePicker_weekdaySun'),
                    },
                ],
            };
        },
        watch: {
            answer: {
                handler(val) {
                    if (val) {
                        this.$emit('getAnswer', this.answer.value);
                    }
                },
                immediate: true,
            },
        },
        computed: {
            checkedWidthOfDevice() {
                let width = window.innerWidth;
                return width < 768;
            },
        },
        methods: {
            exampleDate() {
                if (this.parameters && (this.parameters.date || this.example)) {
                    return this.example ? this.example : this.parameters.date;
                }
            },
            checkAnswer() {
                if (this.answer) {
                    document.activeElement.blur();
                    this.isFocused = false;
                    this.$emit('checkAnswer');
                }
            },
        },
        beforeDestroy() {
            clearTimeout(this.focusTimeout);
        },
    };
</script>

<style scoped lang="scss">
    .example {
        text-align: center;
    }

    .example__container {
        display: flex;
        justify-content: center;
        font-size: $font-size-40;
        font-weight: 500;
        flex-wrap: wrap;
        padding-bottom: 20px;
        @include media($sm) {
            font-size: $font-size-60;
        }
        @include media($md) {
            font-size: $font-size-100;
        }
        @include media($lg) {
            font-size: $font-size-150;
        }
    }
    .example__date-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .example__date-box {
        padding-bottom: 5px;
    }
    .example__date {
        display: flex;
        align-items: center;
        @media screen and (min-width: 360px) {
            font-size: $font-size-14;
        }
        @include media($sm) {
            font-size: $font-size-16;
        }
        @include media($lg) {
            font-size: $font-size-24;
        }
    }
    .example__container_size-big {
        font-size: $font-size-28;
        @include media($sm) {
            font-size: $font-size-42;
        }
        @include media($md) {
            font-size: $font-size-72;
        }
        @include media($lg) {
            font-size: $font-size-100;
        }
    }
    .example__date-picker {
        @media screen and (min-width: 360px) {
            width: 220px;
        }
        @include media($xl) {
            width: 250px;
        }
    }

    .example__container_size-large {
        font-size: $font-size-22;
        @include media($sm) {
            font-size: $font-size-32;
        }
        @include media($md) {
            font-size: $font-size-56;
        }
        @include media($lg) {
            font-size: $font-size-82;
        }
    }

    .example__answer {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include stack-space($space-base);
    }

    .example__answer-header {
        @include stack-space($space-base);
        font-size: 22px;
        font-weight: 500;
        white-space: nowrap;
        @include media($md) {
            font-size: 32px;
        }
    }

    .example__input {
        max-width: 170px;
        margin-right: 10px;
        height: 80px;
        font-size: 22px !important;
        text-align: center;
        @include media($md) {
            max-width: 280px;
            font-size: 32px !important;
        }
    }

    .example_border_overlined {
        position: relative;
    }

    .example__container_size-large .example_border_overlined:after {
        border-top-width: 1px;
        top: 0;
        left: -1px;
        right: 0;
        @include media($sm) {
            border-top-width: 2px;
        }
        @include media($md) {
            border-top-width: 3px;
            top: 2px;
            left: -3px;
        }
        @include media($lg) {
            border-top-width: 5px;
            top: 3px;
            left: -5px;
        }
    }

    .example__container_size-big .example_border_overlined:after {
        border-top-width: 2px;
        top: 0;
        left: -1px;
        @include media($sm) {
            border-top-width: 2px;
            top: 1px;
            left: -2px;
        }
        @include media($md) {
            border-top-width: 4px;
            left: -3px;
        }
        @include media($lg) {
            border-top-width: 6px;
            top: 4px;
        }
    }

    .example_border_overlined:after {
        content: '';
        position: absolute;
        border-top: 2px solid $hsl-color-orange-56;
        top: 1px;
        left: 0;
        right: 0;
        @include media($sm) {
            border-top-width: 4px;
            top: 2px;
            left: -2px;
        }
        @include media($md) {
            border-top-width: 6px;
            top: 4px;
            left: -4px;
        }
        @include media($lg) {
            border-top-width: 8px;
            top: 4px;
            left: -9px;
        }
    }

    .example__part_left {
        color: $hsl-color-blue-56;
    }

    .example__operation {
        color: $hsl-color-orange-56;
    }

    $players-amount-sizes: 12, 6, 4, 3;

    .multiplayer {
        .example {
            .cs-button {
                font-weight: 500;
            }
        }
    }

    @mixin set_overline_size($border-top, $top, $left) {
        .example_border_overlined:after {
            border-top-width: $border-top;
            top: $top;
            left: $left;
        }
    }

    @each $col-size in $players-amount-sizes {
        .multiplayer__item--is-#{$col-size} .example__container {
            @if $col-size == 6 {
                @include set_overline_size(3px, 0, -2px);
                font-size: 40px;
                @include media($xl) {
                    @include set_overline_size(3px, 0, -3px);
                    font-size: 50px;
                }
                @include media($xxl) {
                    @include set_overline_size(4px, 1px, -2px);
                    font-size: 70px;
                }
            }
            @if $col-size == 4 {
                @include set_overline_size(2px, 1px, -1px);
                font-size: 30px;
                @include media($xl) {
                    font-size: 35px;
                }
                @include media($xxl) {
                    @include set_overline_size(3px, 0, -3px);
                    font-size: 50px;
                }
            }
            @if $col-size == 3 {
                @include set_overline_size(2px, 1px, -1px);
                font-size: 30px;
                @include media($xxl) {
                    @include set_overline_size(3px, 0, -2px);
                    font-size: 40px;
                }
            }
        }

        .multiplayer--multiline .multiplayer__item--is-#{$col-size} .example__container {
            @if $col-size == 6 {
                @include set_overline_size(2px, 1px, -1px);
                font-size: 30px;
                @include media($xl) {
                    @include set_overline_size(3px, 0, -3px);
                    font-size: 50px;
                }
            }
            @if $col-size == 4 {
                @include set_overline_size(2px, 1px, -1px);
                font-size: 30px;
                @include media($xl) {
                    font-size: 35px;
                }
                @include media($xxl) {
                    @include set_overline_size(3px, 0, -3px);
                    font-size: 50px;
                }
            }
            @if $col-size == 3 {
                @include set_overline_size(1px, 0, -1px);
                font-size: 22px;
                @include media($xl) {
                    @include set_overline_size(2px, 1px, -1px);
                    font-size: 30px;
                }
                @include media($xxl) {
                    @include set_overline_size(3px, 0, -2px);
                    font-size: 40px;
                }
            }
        }

        .multiplayer__item--is-#{$col-size} .example__input {
            @if $col-size == 6 {
                max-width: 250px;
                max-height: 70px;
                @include media($xl) {
                    max-height: 80px;
                }
            } @else if $col-size == 4 {
                max-width: 180px;
                max-height: 42px;
                @include media($xl) {
                    max-width: 250px;
                    max-height: 60px;
                }
                @include media($xxl) {
                    max-width: 250px;
                    max-height: 80px;
                }
            } @else if $col-size == 3 {
                max-width: 150px;
                max-height: 40px;
                @include media($xl) {
                    max-width: 250px;
                    max-height: 50px;
                }
                @include media($xxl) {
                    max-width: 250px;
                    max-height: 80px;
                }
            }
        }

        .multiplayer--multiline .multiplayer__item--is-#{$col-size} .example__input {
            @if $col-size == 6 {
                max-width: 150px;
                max-height: 40px;
                @include media($xl) {
                    max-width: 250px;
                    max-height: 50px;
                }
            } @else if $col-size == 4 {
                max-width: 150px;
                max-height: 40px;
                @include media($xl) {
                    max-width: 250px;
                    max-height: 50px;
                }
                @include media($xxl) {
                    max-width: 250px;
                    max-height: 60px;
                }
            } @else if $col-size == 3 {
                max-width: 110px;
                max-height: 32px;
                @include media($xl) {
                    max-width: 180px;
                    max-height: 42px;
                }
                @include media($xxl) {
                    max-width: 250px;
                    max-height: 60px;
                }
            }
        }
    }
</style>
